import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/sections/HeroSection';
import TrustBar from '../../components/feature/sections/TrustBar';
import ServicesOverview from '../../components/feature/sections/ServicesOverview';
import AIAnswerBlock from '../../components/feature/sections/AIAnswerBlock';
import ProcessSection from '../../components/feature/sections/ProcessSection';
import WhyChooseUs from '../../components/feature/sections/WhyChooseUs';
import ServiceAreas from '../../components/feature/sections/ServiceAreas';
import TestimonialsSection from '../../components/feature/sections/TestimonialsSection';
import FAQSection from '../../components/feature/sections/FAQSection';
import FinalCTASection from '../../components/feature/sections/FinalCTASection';

const trustItems = [
  { icon: 'ri-map-pin-2-fill', text: 'Located in Brooklyn, NY', subtext: '1247 Flatbush Ave' },
  { icon: 'ri-star-fill', text: '600+ Five-Star Reviews', subtext: 'Brooklyn & NYC' },
  { icon: 'ri-store-3-line', text: '5,000 sq ft Showroom', subtext: 'Open Mon–Sat' },
  { icon: 'ri-car-line', text: 'Free In-Home Estimates', subtext: 'All Brooklyn neighborhoods' },
  { icon: 'ri-history-line', text: 'Serving Brooklyn Since 1998', subtext: '25+ years local' },
];

const services = [
  {
    icon: 'ri-layout-grid-line',
    title: 'Carpet Installation Brooklyn',
    description: 'Brooklyn\'s top-rated carpet installation service. We bring hundreds of carpet samples to you — or visit our Brooklyn showroom for the full selection.',
    href: '/services',
    image: 'https://public.readdy.ai/ai/img_res/606b4ee093407819bf49486ce0fa44b3.jpg',
  },
  {
    icon: 'ri-artboard-line',
    title: 'Tile & Stone — Brooklyn',
    description: 'Ceramic, porcelain, marble, and stone tile flooring installed throughout Brooklyn kitchens, bathrooms, and living areas by our expert crews.',
    href: '/services',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'LVP Flooring Brooklyn',
    description: 'Waterproof luxury vinyl plank is the fastest-growing choice among Brooklyn homeowners. Visit our showroom to see the full selection.',
    href: '/services',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Area Rugs — Brooklyn',
    description: 'Shop Brooklyn\'s best selection of area rugs — from handmade Persian and Oriental rugs to modern contemporary designs.',
    href: '/services',
  },
  {
    icon: 'ri-store-3-line',
    title: 'Brooklyn Showroom',
    description: 'Visit our 5,000 sq ft showroom at 1247 Flatbush Ave. Open Monday–Friday 9–6 and Saturday 10–5. Free parking available.',
    href: '/brooklyn',
  },
];

const aiColumns = [
  {
    heading: 'Flooring Services in Brooklyn, NY',
    paragraphs: [
      'Boro Rug & Flooring is Brooklyn\'s neighborhood flooring company — we\'re not a chain, not a big-box store. We\'re local specialists who have installed floors in thousands of Brooklyn homes and businesses since 1998.',
      'We offer carpet installation, tile and stone flooring, luxury vinyl plank (LVP), and a curated area rug collection — all from our Brooklyn showroom at 1247 Flatbush Ave.',
    ],
  },
  {
    heading: 'Brooklyn Neighborhoods We Serve',
    paragraphs: [
      'We install flooring in every Brooklyn neighborhood — from the brownstones of Park Slope and Brooklyn Heights to the modern condos of DUMBO and Williamsburg, the family homes of Bay Ridge and Bensonhurst, and everywhere in between.',
    ],
    bullets: [
      'Park Slope, Prospect Heights, Crown Heights',
      'Williamsburg, Bushwick, Greenpoint',
      'Bay Ridge, Bensonhurst, Flatbush',
      'DUMBO, Brooklyn Heights, Cobble Hill',
      'Bed-Stuy, Brownsville, East Flatbush',
    ],
  },
  {
    heading: 'Why Brooklyn Homeowners Choose Us',
    paragraphs: [
      'Brooklyn homeowners choose Boro Rug & Flooring because we\'re local, knowledgeable, and accountable. We\'ve built our reputation neighborhood by neighborhood over 25 years — and we protect it on every project.',
    ],
  },
  {
    heading: 'Visit Our Brooklyn Showroom',
    paragraphs: [
      'Our 5,000 sq ft showroom at 1247 Flatbush Ave is one of the largest flooring showrooms in Brooklyn. We carry 500+ samples of carpet, tile, LVP, and area rugs, with design consultants available every day we\'re open.',
    ],
    bullets: [
      '500+ samples on display',
      'Free sample take-home program',
      'Design consultants on staff',
      'Open Mon–Sat for your convenience',
    ],
  },
];

const aiStats = [
  { value: '1998', label: 'Serving Brooklyn since' },
  { value: '5K+', label: 'Brooklyn projects completed' },
  { value: '500+', label: 'Showroom samples' },
  { value: '5,000', label: 'Square foot showroom' },
];

const processSteps = [
  { icon: 'ri-store-3-line', title: 'Visit Flatbush Showroom', description: 'Find us at 1247 Flatbush Ave, Brooklyn. 500+ flooring samples on display. Free parking. Mon–Fri 9–6, Sat 10–5.' },
  { icon: 'ri-home-take-away-line', title: 'Take Samples Home', description: 'Borrow samples to evaluate flooring under your home\'s lighting — completely free, no commitment required.' },
  { icon: 'ri-calendar-check-line', title: 'Schedule In-Home Estimate', description: 'We come to your Brooklyn home to measure and provide a detailed, transparent estimate.' },
  { icon: 'ri-tools-line', title: 'Prep & Install', description: 'Our Brooklyn-based crews handle old floor removal, subfloor prep, and expert installation.' },
  { icon: 'ri-checkbox-circle-line', title: 'Final Walkthrough', description: 'We inspect every inch with you to ensure the finished floor exceeds your expectations.' },
  { icon: 'ri-customer-service-2-line', title: 'Brooklyn-Based Support', description: 'We\'re your neighbors. Any post-install questions or needs are handled promptly — no corporate runaround.' },
];

const benefits = [
  { icon: 'ri-map-pin-2-fill', title: 'Brooklyn Showroom & Warehouse', description: 'Visit our 5,000 sq ft showroom at 1247 Flatbush Ave. Everything you need for your flooring project in one location.' },
  { icon: 'ri-team-line', title: 'Local Brooklyn Crews', description: 'Our installation teams live and work in Brooklyn. They know the housing stock, building types, and unique challenges of NYC homes.' },
  { icon: 'ri-history-line', title: '25 Years in the Neighborhood', description: 'Since 1998 we\'ve built Brooklyn floor by floor. Our reputation in this community is everything to us.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Brooklyn-Fair Pricing', description: 'We price fairly for the Brooklyn market — no big-box markups, no chain-store games. Just honest estimates.' },
  { icon: 'ri-thumb-up-line', title: 'Brooklyn\'s Most Reviewed', description: 'Over 600 five-star reviews from real Brooklyn homeowners on Google and Yelp make us Brooklyn\'s top-rated flooring company.' },
];

const brooklynAreas = [
  'Park Slope', 'Brooklyn Heights', 'DUMBO', 'Williamsburg', 'Greenpoint',
  'Crown Heights', 'Prospect Heights', 'Flatbush', 'Midwood', 'Bay Ridge',
  'Bensonhurst', 'Bushwick', 'Bed-Stuy', 'Cobble Hill', 'Carroll Gardens',
  'Fort Greene', 'Boerum Hill', 'Red Hook', 'Sheepshead Bay', 'Brighton Beach',
];

const testimonials = [
  {
    name: 'Maria G.',
    location: 'Flatbush, Brooklyn',
    rating: 5,
    text: 'I live five minutes from their showroom on Flatbush Ave — I walked in not knowing what I wanted and walked out with samples for three types of flooring. Two weeks later my apartment has beautiful new LVP throughout. The whole experience was seamless and local.',
    service: 'LVP Installation',
  },
  {
    name: 'Anthony P.',
    location: 'Bay Ridge, Brooklyn',
    rating: 5,
    text: 'Boro Rug has been in our neighborhood for decades and there\'s a reason for that. They installed tile in our kitchen and bathrooms and carpet in the bedrooms — all in one project. Flawless execution, fair pricing, and genuinely nice people.',
    service: 'Tile & Carpet Installation',
  },
  {
    name: 'Denise O.',
    location: 'Prospect Heights, Brooklyn',
    rating: 5,
    text: 'I searched for flooring companies in Brooklyn and Boro Rug kept coming up as the best. After working with them I completely understand why. Professional from estimate to install, and the carpet in my brownstone looks absolutely beautiful.',
    service: 'Carpet Installation',
  },
  {
    name: 'Marcus H.',
    location: 'Crown Heights, Brooklyn',
    rating: 5,
    text: 'As a Brooklyn landlord, I need reliable flooring contractors who do quality work fast. Boro Rug has handled three of my renovation projects. Every time: on time, on budget, quality result. They\'re my go-to for every Brooklyn property.',
    service: 'Commercial Flooring',
  },
  {
    name: 'Stephanie C.',
    location: 'Williamsburg, Brooklyn',
    rating: 5,
    text: 'The showroom on Flatbush is a hidden gem. I went expecting a small store and found a massive, beautifully organized space with hundreds of options. The consultant was honest, knowledgeable, and not pushy at all. So refreshing.',
    service: 'Showroom Consultation',
  },
];

const faqs = [
  {
    question: 'Who installs flooring near me in Brooklyn?',
    answer: 'Boro Rug & Flooring is Brooklyn\'s top-rated local flooring company, based at 1247 Flatbush Ave. We install carpet, tile, stone, and luxury vinyl plank throughout all Brooklyn neighborhoods. Family-owned since 1998, our local crews are experienced with Brooklyn\'s brownstones, co-ops, and modern residential buildings.',
  },
  {
    question: 'Where is the Boro Rug & Flooring showroom in Brooklyn?',
    answer: 'Our showroom is located at 1247 Flatbush Ave in Brooklyn, NY 11226 — conveniently accessible from Park Slope, Crown Heights, Flatbush, and Prospect Heights. We\'re open Monday–Friday 9am–6pm and Saturday 10am–5pm. Free parking is available. Walk-ins are welcome.',
  },
  {
    question: 'Do you offer flooring installation in all Brooklyn neighborhoods?',
    answer: 'Yes, we serve every Brooklyn neighborhood — Park Slope, Williamsburg, Crown Heights, Bay Ridge, Flatbush, DUMBO, Brooklyn Heights, Bensonhurst, Bushwick, Greenpoint, and more. We also serve Manhattan, Queens, Staten Island, and the Bronx. Call for a free in-home estimate anywhere in Brooklyn.',
  },
  {
    question: 'How much does flooring installation cost in Brooklyn, NY?',
    answer: 'Flooring costs in Brooklyn vary by material: carpet installation runs $3–$7 per sq ft installed, tile starts at $8–$15 per sq ft, and LVP typically costs $5–$10 per sq ft installed. We provide free, detailed in-home estimates so you know exactly what you\'ll pay before any work begins.',
  },
  {
    question: 'How do I schedule a flooring estimate in Brooklyn?',
    answer: 'Call us at (718) 555-0100, visit our showroom at 1247 Flatbush Ave, or submit an estimate request on our website. We\'ll schedule a free in-home visit to measure your Brooklyn home and provide a transparent quote. Most estimates are available within 24–48 hours of your request.',
  },
  {
    question: 'Do you have a flooring showroom open on weekends in Brooklyn?',
    answer: 'Yes! Our Brooklyn showroom is open Saturday from 10am–5pm. We\'re closed Sunday. During the week we\'re open Monday through Friday 9am–6pm. Our design consultants are available during all open hours to help you choose the perfect flooring for your home or business.',
  },
];

export default function BrooklynPage() {
  return (
    <div className="bg-ivory">
      <Navbar />

      <HeroSection
        headline="Flooring Installation & Showroom in Brooklyn, NY"
        subheadline="Visit Brooklyn's premier flooring showroom at 1247 Flatbush Ave — or let us come to you with a free in-home estimate."
        primaryCTA={{ label: 'Get Free Estimate', href: '/#quote' }}
        secondaryCTA={{ label: 'Get Directions', href: 'https://maps.google.com/?q=1247+Flatbush+Ave+Brooklyn+NY' }}
        trustSignal="Brooklyn's top-rated flooring company"
        bgImage="https://readdy.ai/api/search-image?query=brooklyn%20new%20york%20street%20view%20modern%20renovated%20brownstone%20residential%20buildings%20beautiful%20neighborhood%20with%20clean%20elegant%20residential%20storefronts%20bright%20sunny%20day%20warm%20tones%20community%20feel&width=1400&height=900&seq=hero-bk2&orientation=landscape"
        badge="Flooring Brooklyn NY — 1247 Flatbush Ave"
        floatingBadgeTitle="Open Mon–Sat"
        floatingBadgeText="1247 Flatbush Ave, Brooklyn NY 11226"
      />

      <TrustBar items={trustItems} />

      <ServicesOverview
        title="Flooring Services for Brooklyn Homes"
        subtitle="From our Brooklyn showroom to every neighborhood — carpet, tile, LVP, and area rugs installed by local experts."
        services={services}
        ctaLabel="Learn More"
      />

      <AIAnswerBlock
        badge="Flooring Brooklyn NY"
        title="Brooklyn's Neighborhood Flooring Company Since 1998"
        headline="We\'ve installed floors in thousands of Brooklyn homes — brownstones, co-ops, condos, and commercial spaces — with local knowledge and local pride."
        columns={aiColumns}
        stats={aiStats}
        sidebarTitle="Our Brooklyn Numbers"
      />

      <ProcessSection
        title="Getting New Floors in Brooklyn Is Easy"
        subtitle="Designed specifically for busy Brooklyn homeowners — a simple, transparent process from first visit to finished floor."
        steps={processSteps}
      />

      <WhyChooseUs
        title="Brooklyn's Flooring Specialists — In Your Neighborhood"
        subtitle="We\'re not a chain — we\'re your neighbors. 25 years of local flooring expertise, local crews, and local accountability."
        benefits={benefits}
        image="https://readdy.ai/api/search-image?query=brooklyn%20flooring%20showroom%20interior%20beautiful%20light%20airy%20space%20carpet%20tile%20vinyl%20samples%20displayed%20on%20walls%20bright%20white%20professional%20interior%20with%20natural%20light%20welcoming%20atmosphere&width=800&height=700&seq=why-bk2&orientation=portrait"
        image2="https://readdy.ai/api/search-image?query=flooring%20installer%20professional%20working%20in%20brooklyn%20brownstone%20home%20installing%20vinyl%20plank%20floor%20in%20bright%20renovated%20interior&width=400&height=300&seq=why-bk2b&orientation=landscape"
        ctaLabel="Visit Our Showroom"
        badge="Your Brooklyn Flooring Team"
        badgeTitle="Open Mon–Sat"
        badgeSubtext="1247 Flatbush Ave, Brooklyn NY"
      />

      <ServiceAreas
        title="Every Brooklyn Neighborhood Covered"
        subtitle="Free in-home estimates across all of Brooklyn and NYC."
        description="From the brownstones of Park Slope to the family homes of Bay Ridge — Boro Rug & Flooring installs carpet, tile, LVP, and area rugs throughout every Brooklyn neighborhood. We also serve Manhattan, Queens, the Bronx, and Staten Island. Flooring installation Brooklyn NY — call us or visit the showroom to get started."
        areas={brooklynAreas}
      />

      <TestimonialsSection testimonials={testimonials} />

      <FAQSection
        title="Brooklyn Flooring FAQ"
        faqs={faqs}
      />

      <FinalCTASection
        headline="Visit Brooklyn's Best Flooring Showroom"
        subheadline="1247 Flatbush Ave, Brooklyn NY — or call us for a free in-home estimate anywhere in Brooklyn."
        bgImage="https://readdy.ai/api/search-image?query=luxury%20brooklyn%20brownstone%20interior%20with%20stunning%20new%20flooring%20beautiful%20warm%20wood%20planks%20bright%20spacious%20renovated%20living%20room%20elegant%20furniture%20high%20end%20residential%20brooklyn%20new%20york&width=1600&height=900&seq=cta-bk2&orientation=landscape"
        formAction="https://readdy.ai/api/form/d6umjl5t4s7j0tv5i6b0"
        checkItems={['Free in-home estimates', 'Local Brooklyn crews', 'All neighborhoods served']}
      />

      <Footer />
    </div>
  );
}
